import { ProjectStatus } from "$types/ProjectStatus";

export const PROJECT_STATUS_LABELS = {
  [ProjectStatus.IN_PROGRESS]: "En cours",
  [ProjectStatus.DONE]: "Terminé",
};

export const getProjectStatusOptions = () =>
  Object.keys(PROJECT_STATUS_LABELS).map((key) => ({
    value: key,
    label: PROJECT_STATUS_LABELS[key],
  }));
